var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coche",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.984,
    height: 26.297,
    viewBox: "0 0 37.984 26.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7386",
    "data-name": "Trazado 7386",
    d: "M27.767,14.769H24.845a1.461,1.461,0,0,0-1.461,1.461v5.844a1.461,1.461,0,0,0,1.461,1.461h2.922a1.461,1.461,0,0,0,1.461-1.461V16.23A1.461,1.461,0,0,0,27.767,14.769Z",
    transform: "translate(4.373 2.762)",
    fill: "#6d6d6d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7387",
    "data-name": "Trazado 7387",
    d: "M8.075,14.769H5.153A1.461,1.461,0,0,0,3.692,16.23v5.844a1.461,1.461,0,0,0,1.461,1.461H8.075a1.461,1.461,0,0,0,1.461-1.461V16.23A1.461,1.461,0,0,0,8.075,14.769Z",
    transform: "translate(0.691 2.762)",
    fill: "#6d6d6d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7388",
    "data-name": "Trazado 7388",
    d: "M32.911,11.688H3.692L7.813,1.8A2.922,2.922,0,0,1,10.51,0H26.094a2.922,2.922,0,0,1,2.7,1.8ZM28.529,8.766H8.075L10.51,2.922H26.094Z",
    transform: "translate(0.691 0)",
    fill: "#f44336",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7389",
    "data-name": "Trazado 7389",
    d: "M3.652,6.154H2.191a2.191,2.191,0,0,0,0,4.383H3.652a2.191,2.191,0,1,0,0-4.383Z",
    transform: "translate(0 1.151)",
    fill: "#f44336"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7390",
    "data-name": "Trazado 7390",
    d: "M30.729,6.154H29.268a2.191,2.191,0,0,0,0,4.383h1.461a2.191,2.191,0,0,0,0-4.383Z",
    transform: "translate(5.064 1.151)",
    fill: "#f44336"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7391",
    "data-name": "Trazado 7391",
    d: "M28.759,7.385H8.305a5.844,5.844,0,0,0-5.844,5.844V16.15a5.844,5.844,0,0,0,5.844,5.844H28.759A5.844,5.844,0,0,0,34.6,16.15V13.228A5.844,5.844,0,0,0,28.759,7.385Z",
    transform: "translate(0.46 1.381)",
    fill: "#f44336"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7392",
    "data-name": "Trazado 7392",
    d: "M7.845,16.921A2.922,2.922,0,1,0,4.923,14,2.922,2.922,0,0,0,7.845,16.921Z",
    transform: "translate(0.921 2.072)",
    fill: "#ffd500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7393",
    "data-name": "Trazado 7393",
    d: "M25.076,16.921A2.922,2.922,0,1,0,22.154,14,2.922,2.922,0,0,0,25.076,16.921Z",
    transform: "translate(4.143 2.072)",
    fill: "#ffd500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7394",
    "data-name": "Trazado 7394",
    d: "M15.23,12.538a1.461,1.461,0,1,0-2.922,0V15.46a1.461,1.461,0,1,0,2.922,0Z",
    transform: "translate(2.302 2.072)",
    fill: "rgba(0,0,0,0.4)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7395",
    "data-name": "Trazado 7395",
    d: "M20.152,12.538a1.461,1.461,0,1,0-2.922,0V15.46a1.461,1.461,0,1,0,2.922,0Z",
    transform: "translate(3.222 2.072)",
    fill: "rgba(0,0,0,0.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar2);
export default __webpack_public_path__ + "static/media/car-2.852247b180be4cc7d159380585702d14.svg";
export { ForwardRef as ReactComponent };